import Table from "react-bootstrap/Table";
import "../Styles/Admin.css";
import ActiveIcon from "../Assets/Icons/activeIcon.svg";
import InActiveIcon from "../Assets/Icons/inActiveIcon.svg";
import { Button } from "react-bootstrap";
import CheckMarkIcon from "../Assets/Icons/checkMarkIcon.svg";
import ExportIcon from "../Assets/Icons/exportIcon.svg";

export default function SubscribeTable() {
  return (
    <Table style={{ textAlign: "center" }} hovered variant="light">
      <thead>
        <tr>
          <th
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "6px 0px 0px 0px",
            }}
          >
            MERCHANT
          </th>
          <th style={{ backgroundColor: "#E0E0E0" }}>Amount</th>
          <th style={{ backgroundColor: "#E0E0E0" }}>Date</th>
          <th style={{ backgroundColor: "#E0E0E0" }}>STATUS</th>
          <th
            style={{
              backgroundColor: "#E0E0E0",
              borderRadius: "0px 6px 0px 0px",
            }}
          >
            ACTION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Naseem Muneer</td>
          <td>N 564654</td>
          <td>Jun 12-2023</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={CheckMarkIcon} /> Success
            </div>
          </td>
          <td>
          {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
                color: "#008BD9",
                cursor: "pointer",
              }}
            >
              <img style={{ marginTop: "1px" }} src={ExportIcon} /> Download
            </div>
          </td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>N 564654</td>
          <td>Jun 12-2023</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={CheckMarkIcon} /> Success
            </div>
          </td>
          <td>
          {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
                color: "#008BD9",
                cursor: "pointer",
              }}
            >
              <img style={{ marginTop: "1px" }} src={ExportIcon} /> Download
            </div>
          </td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>N 564654</td>
          <td>Jun 12-2023</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={CheckMarkIcon} /> Success
            </div>
          </td>
          <td>
          {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
                color: "#008BD9",
                cursor: "pointer",
              }}
            >
              <img style={{ marginTop: "1px" }} src={ExportIcon} /> Download
            </div>
          </td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>N 564654</td>
          <td>Jun 12-2023</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={CheckMarkIcon} /> Success
            </div>
          </td>
          <td>
          {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
                color: "#008BD9",
                cursor: "pointer",
              }}
            >
              <img style={{ marginTop: "1px" }} src={ExportIcon} /> Download
            </div>
          </td>
        </tr>
        <tr>
          <td>Naseem Muneer</td>
          <td>N 564654</td>
          <td>Jun 12-2023</td>
          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
              }}
            >
              <img style={{ marginTop: "1px" }} src={CheckMarkIcon} /> Success
            </div>
          </td>
          <td>
          {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                justifyContent: "center",
                color: "#008BD9",
                cursor: "pointer",
              }}
            >
              <img style={{ marginTop: "1px" }} src={ExportIcon} /> Download
            </div>
          </td>
        </tr>
      </tbody>
    </Table>
  );
}
